import { createSlice } from "@reduxjs/toolkit"


var data=[]


if (localStorage.getItem("commmodity") !== null && localStorage.getItem("commmodity") !== undefined && localStorage.getItem("commmodity") !== "") {

    data = JSON.parse(localStorage.getItem("commmodity"))

}


const Insider = createSlice({

    name: "todos",
    initialState: data,
    reducers: {
        getcommodity: (state, action) => {
            localStorage.setItem("commmodity", JSON.stringify(action.payload.data))
            state = action.payload.data
            return state
        
          
        },

    },

})

export const { getcommodity } = Insider.actions;
export default Insider.reducer;